import { supabase } from './supabaseClient';

// Sends notification via Supabase Edge Function
export async function sendNotification(type, data, settings) {
  if (!settings?.emailNotifications) return;
  if (!settings?.smtpHost || !settings?.smtpUser || !settings?.smtpPassword) return;
  if (!settings?.adminEmail) return;

  // Check if this notification type is enabled
  const typeEnabled = {
    decommission:    settings.notifyDecommission,
    delivery:        settings.notifyDelivery,
    checkout_overdue: settings.notifyOverdue,
    low_stock:       settings.lowStockAlerts,
    maintenance:     settings.notifyMaintenance,
    new_user:        settings.notifyNewUser,
  };

  if (!typeEnabled[type]) return;

  try {
    const { error } = await supabase.functions.invoke('send-notification', {
      body: {
        type,
        smtp: {
          host:      settings.smtpHost,
          port:      Number(settings.smtpPort) || 587,
          user:      settings.smtpUser,
          password:  settings.smtpPassword,
          fromName:  settings.smtpFromName || 'RFID WMS',
          fromEmail: settings.smtpFromEmail || settings.smtpUser,
        },
        adminEmail: settings.adminEmail,
        data,
      },
    });

    if (error) console.warn('[Notification] Failed:', error.message);
    else console.log(`[Notification] ✓ Sent: ${type}`);
  } catch(e) {
    console.warn('[Notification] Error:', e.message);
  }
}
